import {configureStore,} from "@reduxjs/toolkit";
import {UILeftMenuReducer} from "@/components/Menu/LeftMenu/Slice/UILeftMenuSlice";
import {CurrentUserReducer, setToken} from "@/features/Auth/CurrentUser/Slice/CurrentUserSlice";
import {AccessTokenStorageService} from "@/features/Auth/CurrentUser/Services/AccessTokenStorageService";
import {GetCurrentUserApiSlice} from "@/api/Users/GetCurrentUser/GetCurrentUserApiSlice";
import {isDevMode} from "@/helpers/mode";
import {ApiSlice} from "@/store/ApiSlice";
import {DaDataApiSlice} from "@/features/PartnerOnboarding/api/DaDataApiSlice";
import {
    RegisterNewPartnerFormReducer
} from "@/features/InControlPanel/RegisterNewPartnerForm/Slice/RegisterNewPartnerFormSlice";
import {
    RegisterNewPartnerPhysicalAddressReducer
} from "@/features/InControlPanel/RegisterNewPartnerForm/Slice/PhysicalAddressSlice";
import {ContactsReducer} from "@/features/InControlPanel/RegisterNewPartnerForm/Slice/ContactsSlice";
import {LoginFormReducer} from "@/features/Auth/LoginForm/Slice/LoginFormSlice";
import {LogoutReducer} from "@/features/Auth/CurrentUser/Slice/LogoutSlice";
import {OrderDNATestFormReducer} from "@/features/OrderDNATestForm/Slice/OrderDNATestFormSlice";
import {DNAOrdersFiltersAndSortersReducer} from "@/features/DNAOrders/Slice/DNAOrdersFiltersAndSortersSlice";
import {OpenedDNAOrderReducer} from "@/features/DNAOrderContent/Slice/OpenedDNAOrderSlice";
import {
    CreateArticleFormReducer
} from "@/features/InControlPanel/KnowledgeBase/CreateArticleForm/Slice/CreateArticleFormSlice";
import {CategoriesTreeReducer} from "@/features/InControlPanel/KnowledgeBase/CategoriesTree/Slice/CategoriesTreeSlice";
import {
    ArticlesOfCategoryReducer
} from "@/features/InControlPanel/KnowledgeBase/ArticlesOfCategory/Slice/ArticlesOfCategorySlice";
import {OpenedArticleReducer} from "@/features/KnowledgeBase/OpenedArticle/Slice/OpenedArticleSlice";
import {
    ArticlesInTrashReducer
} from "@/features/InControlPanel/KnowledgeBase/ArticlesInTrash/Slice/ArticlesInTrashSlice";
import {
    EditArticleFormReducer
} from "@/features/InControlPanel/KnowledgeBase/EditArticleForm/Slice/EditArticleFormSlice";
import {
    KnowledgeBaseCategoriesInTrashReducer
} from "@/features/InControlPanel/KnowledgeBase/CategoriesInTrash/Slice/KnowledgeBaseCategoriesInTrashSlice";
import {
    KnowledgeBaseAddCategoryReducer
} from "@/features/InControlPanel/KnowledgeBase/CategoriesTree/Slice/AddCategorySlice";
import {
    KnowledgeBaseEditCategoryReducer
} from "@/features/InControlPanel/KnowledgeBase/CategoriesTree/Slice/EditCategorySlice";
import {PersonalManagerContactsReducer} from "@/features/PersonalManagerContacts/Slice/PersonalManagerContactsSlice";
import {CreateUserFormReducer} from "@/features/InControlPanel/Users/CreateUser/Slice/CreateUserFormSlice";
import {UsersListReducer} from "@/features/InControlPanel/Users/UsersList/Slice/UsersListSlice";
import {EditUserFormReducer} from "@/features/InControlPanel/Users/EditUser/Slice/EditUserFormSlice";
import {EditPartnerFormReducer} from "@/features/InControlPanel/EditPartnerForm/Slice/EditPartnerFormSlice";
import {
    EditPartnerPhysicalAddressReducer
} from "@/features/InControlPanel/EditPartnerForm/Slice/EditPartnerPhysicalAddressSlice";
import {
    EditPartnerFormContactsReducer
} from "@/features/InControlPanel/EditPartnerForm/Slice/EditPartnerFormContactsSlice";
import {DeletingUserReducer} from "@/features/InControlPanel/Users/UsersList/Slice/DeletingUserSlice";
import {
    ApplicationsListReducer
} from "@/features/InControlPanel/ApplicationsForChangePersonalData/Slice/ApplicationsListSlice";
import {LangReducer} from "@/features/LangSwitcher/Slice/LangSlice";
import {CurrentCategoryReducer} from "@/features/KnowledgeBase/CategoriesTree/Slice/CurrentCategorySlice";
import {PartnerFirstEntryReducer} from "@/features/PartnerFirstEntryCheck/Slice/PartnerFirstEntrySlice";
import {CreateAppealFormReducer} from "@/features/Appeals/CreateAppealForm/Slice/CreateAppealFormSlice";
import {DNATestsReducer} from "@/features/DNATestsContent/Slice/DNATestsSlice";
import {CallCourierReducer} from "@/features/OrderDNATestForm/Slice/CallCourierSlice";
import {OpenedOrderLabFilesReducer} from "@/features/DNAOrderContent/Slice/OpenedOrderLabFilesSlice";
import {EditDNATestFormReducer} from "@/features/EditDNATestForm/Slice/EditDNATestFormSlice";
import {rtkQueryErrorLogger} from "./rtkQueryErrorLogger";
import {ShowGlobalErrorReducer} from "@/components/ShowGlobalError/Slice/ShowGlobalErrorSlice";
import {CallCourierInOpenOrderReducer} from "@/features/DNAOrderContent/Slice/CallCourierInOpenOrderSlice";
import {NotificationsReducer} from "@/features/Notifications/Slice/NotificationsSlice";
import {
    TicketStatusesReducer
} from "@/features/InControlPanel/ReferenceBooks/Tickets/Statuses/Slice/TicketStatusesSlice";
import {CreateEditBannerFormReducer} from "@/features/Banner/Slice/CreateEditBannerFormSlice";
import {CreateTicketByStaffReducer} from "@/features/Appeals2/CreateTicketByStaff/Slice/CreateTicketByStaffSlice";
import {
    DatesForTheEndCustomerReducer
} from "@/features/DNAOrderContent/DatesForTheEndCustomer/Slice/DatesForTheEndCustomerSlice";
import {CountriesReducer} from "@/features/InControlPanel/ReferenceBooks/GEO/Countries/Slice/CountriesSlice";
import {CitiesReducer} from "@/features/InControlPanel/ReferenceBooks/GEO/Cities/Slice/CitiesSlice";
import {DocumentTypesReducer} from "@/features/InControlPanel/ReferenceBooks/DocumentTypes/Slice/DocumentTypesSlice";
import {
    LaboratoryLegalEntitiesReducer
} from "@/features/InControlPanel/ReferenceBooks/LaboratoryLegalEntities/Slice/LaboratoryLegalEntitiesSlice";
import {
    DocumentStatusesReducer
} from "@/features/InControlPanel/ReferenceBooks/DocumentStatuses/Slice/DocumentStatusesSlice";
import {
    OrganizationalLegalFormsReducer
} from "@/features/InControlPanel/ReferenceBooks/OrganizationalLegalForms/Slice/OrganizationalLegalFormsSlice"
import {RequisitesFormsReducer} from "@/features/InControlPanel/ReferenceBooks/Requisites/Slice/RequisitesFormsSlice";
import {
    OLFToRequisitesRuleFormsReducer
} from "@/features/InControlPanel/ReferenceBooks/OLFToRequisitesRule/Slice/OLFToRequisiteRuleFormsSlice";

import {ErrorsReducer} from "@/features/InControlPanel/ReferenceBooks/Errors/Slice/ErrorsSlice";
import {
    FamilyStepsReducer
} from "@/features/InControlPanel/ReferenceBooks/FamilySteps/Slice/FamilyStepsSlice";
import {
    AttributeSelectionRulesReducer
} from "@/features/InControlPanel/ReferenceBooks/AttributeSelectionRules/Slice/AttributeSelectionRulesSlice";
import {
    AttributeRuleForNParticipantsReducer
} from "@/features/InControlPanel/ReferenceBooks/AttributeRuleForNParticipants/Slice/AttributeSelectionRulesSlice";
import {
    DescribeKinshipSurveyReducer
} from "@/features/InControlPanel/ReferenceBooks/DescribeKinshipSurvey/Slice/DescribeKinshipSurveySlice";
import {
    AnswerTypeRulesReducer
} from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/AnswerTypeRules/Slice/AnswerTypeRulesSlice";
import {RolesReducer} from "@/features/InControlPanel/Settings/Roles/Slice/RolesSlice";
import {SectionsReducer} from "@/features/InControlPanel/Settings/Sections/Slice/SectionsSlice";
import {PermissionsReducer} from "@/features/InControlPanel/Settings/Permissions/Slice/PermissionsSlice";
import {SettingsMenuReducer} from "@/features/InControlPanel/Settings/Menu/Slice/SettingsMenuSlice";
import {MenuReducer} from "@/features/Menu/Slice/MenuSlice";
import {HintsReducer} from "@/features/InControlPanel/ReferenceBooks/Hints/Slice/HintsSlice";
import {
    FileMeaningsReducer
} from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/Slice/FileMeaningsSlice";
import {
    FileExtensionsReducer
} from "@/features/InControlPanel/ReferenceBooks/Files/FileExtensions/Slice/FileExtensionsSlice";
import {MassiveMailingReducer} from "@/features/InControlPanel/MassiveMailing/Slice/MassiveMailingSlice";
import {LoginAsReducer, setOriginalUser} from "@/features/Auth/LoginAs/Slice/LoginAsSlice";
import {OriginalUserStorageService} from "@/features/Auth/LoginAs/Services/OriginalUserStorageService";
import {
    LaboratoryQuestionsStatusesReducer
} from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/LaboratoryQuestionsStatuses/Slice/LaboratoryQuestionsStatusesSlice";

const configuredStore = configureStore({
    reducer: {
        uiLeftMenu: UILeftMenuReducer,
        lang: LangReducer,
        currentUser: CurrentUserReducer,
        loginAs: LoginAsReducer,

        registerNewPartnerForm: RegisterNewPartnerFormReducer,
        registerNewPartnerPhysicalAddress: RegisterNewPartnerPhysicalAddressReducer,
        inCPEditPartnerForm: EditPartnerFormReducer,
        inCPEditPartnerFormPhysicalAddress: EditPartnerPhysicalAddressReducer,
        contacts: ContactsReducer,
        inCPEditPartnerFormContacts: EditPartnerFormContactsReducer,
        loginForm: LoginFormReducer,
        logout: LogoutReducer,

        orderDNATestForm: OrderDNATestFormReducer,
        callCourier: CallCourierReducer,

        editDNATestForm: EditDNATestFormReducer,

        dnaOrdersFiltersAndSorters: DNAOrdersFiltersAndSortersReducer,
        openedDNAOrder: OpenedDNAOrderReducer,
        openedDNAOrderLabFiles: OpenedOrderLabFilesReducer,
        callCourierInOpenOrder: CallCourierInOpenOrderReducer,

        inCPCreateArticleForm: CreateArticleFormReducer,
        inCPEditArticleForm: EditArticleFormReducer,
        inCPKnowledgeBaseCategoriesTree: CategoriesTreeReducer,
        inCPArticlesOfCategoryOfKnowledgeBase: ArticlesOfCategoryReducer,
        inCPArticlesInTrashInKnowledgeBase: ArticlesInTrashReducer,
        inCPCategoriesInTrashInKnowledgeBase: KnowledgeBaseCategoriesInTrashReducer,
        inCPAddCategoryInKnowledgeBase: KnowledgeBaseAddCategoryReducer,
        inCpEditCategoryInKnowledgeBase: KnowledgeBaseEditCategoryReducer,

        openedArticleOfKnowledgeBase: OpenedArticleReducer,
        currentCategoryOfKnowledgeBase: CurrentCategoryReducer,

        personalManagerContacts: PersonalManagerContactsReducer,

        inCPCreateUserForm: CreateUserFormReducer,
        inCPUsersList: UsersListReducer,
        inCPDeletingUser: DeletingUserReducer,
        inCPEditUserForm: EditUserFormReducer,

        inCPApplicationsList: ApplicationsListReducer,

        partnerFirstEntry: PartnerFirstEntryReducer,

        // appeals
        appealsCreateForm: CreateAppealFormReducer,
        ticketStatuses: TicketStatusesReducer,

        //dna tests
        dnaTests: DNATestsReducer,

        notifications: NotificationsReducer,

        globalError: ShowGlobalErrorReducer,
        createEditBannerForm: CreateEditBannerFormReducer,

        createTicketByStaff: CreateTicketByStaffReducer,
        datesForTheEndCustomer: DatesForTheEndCustomerReducer,

        countries: CountriesReducer,
        cities: CitiesReducer,
        documentTypes: DocumentTypesReducer,
        laboratoryLegalEntities: LaboratoryLegalEntitiesReducer,
        documentStatuses: DocumentStatusesReducer,
        errors: ErrorsReducer,

        organizationalLegalForms: OrganizationalLegalFormsReducer,
        requisitesForms: RequisitesFormsReducer,
        olfToRequisitesRuleForms: OLFToRequisitesRuleFormsReducer,
        familySteps: FamilyStepsReducer,
        attributeSelectionRules: AttributeSelectionRulesReducer,
        attributeRuleForNParticipants: AttributeRuleForNParticipantsReducer,
        describeKinshipSurvey: DescribeKinshipSurveyReducer,
        answerTypeRules: AnswerTypeRulesReducer,
        laboratoryQuestionsStatuses: LaboratoryQuestionsStatusesReducer,
        roles: RolesReducer,
        sections: SectionsReducer,
        permissions: PermissionsReducer,
        settingsMenu: SettingsMenuReducer,
        menu: MenuReducer,
        hints: HintsReducer,
        massiveMailing: MassiveMailingReducer,
        fileMeanings: FileMeaningsReducer,
        fileExtensions: FileExtensionsReducer,
        [ApiSlice.reducerPath]: ApiSlice.reducer,
        [DaDataApiSlice.reducerPath]: DaDataApiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(ApiSlice.middleware, DaDataApiSlice.middleware, rtkQueryErrorLogger),
    devTools: isDevMode()
});

AccessTokenStorageService.onTokenChanged(() => {
    const tokenStorageService = new AccessTokenStorageService();
    const token = tokenStorageService.getTokenFromStorage();

    const dispatch: AppDispatch = configuredStore.dispatch;

    dispatch(setToken(token));
    dispatch(ApiSlice.util.resetApiState());

    if (token) {
        dispatch(GetCurrentUserApiSlice.endpoints.getCurrentUser.initiate());
    }
});

OriginalUserStorageService.onOriginalUserChanged(() => {
    const originalUserStorageService = new OriginalUserStorageService();
    const originalUser = originalUserStorageService.getFromStorage();
    configuredStore.dispatch(setOriginalUser(originalUser));
});

export default configuredStore;

export type RootState = ReturnType<typeof configuredStore.getState>;
export type AppDispatch = typeof configuredStore.dispatch;
